export const SET_DAILY_CURRENT_VIEW = 'setDailyCurrentView';
export const SET_DAILY_SEARCH_INFO = 'setDailySearchInfo';
export const SET_DAILY_CLUSTER_REPORT = 'setClusterReport';
export const SET_DAILY_SEARCH_PARAMS = 'setDailySearchParams';



// WEBPACK FOOTER //
// ./src/modules/Statistics/_store/mutations_type.js